import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Notification from 'app/components/general/Notification';
import classnames from 'classnames';

import { Link } from 'react-router-dom';

import history from 'app/routes/history';
import HeaderThin from 'app/components/layout/HeaderThin';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import MatchesTable from 'app/components/matches/MatchesTable';

import _ from 'lodash';
import {
  ITeamsSelector, IPaymentEventsSelector, IOrganisationsSelector, IGroupsSelector,
} from 'app/types/selector';
import * as paymentEventsActions from 'app/ducks/paymentEvents/actions';
import * as teamsActions from 'app/ducks/teams/actions';
import * as groupsActions from 'app/ducks/groups/actions';
import * as teamPaymentRequestsActions from 'app/ducks/teamPaymentRequests/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import * as groupsSelectors from 'app/ducks/groups/selectors';
import * as teamPaymentRequestsSelectors from 'app/ducks/teamPaymentRequests/selectors';

import PaymentCardMin from 'app/components/matches/PaymentCardMin';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    paymentEvents: paymentEventsSelectors.getPaymentEvents(state),
    teams: teamsSelectors.getTeams(state),
    organisations: organisationsSelectors.getOrganisations(state),
    teamPaymentRequests: teamPaymentRequestsSelectors.getTeamPaymentRequests(state),
    groups: groupsSelectors.getGroups(state),
    isLoading: state.payments.isLoading,
    errors: { ...state.paymentEvents.backendErrors },
  };
}

const actionCreators = _.merge(paymentEventsActions, teamsActions, groupsActions, teamPaymentRequestsActions);

interface IListPaymentsAllTeamsProps {
  appReady: any;
  teams: ITeamsSelector;
  paymentEvents: IPaymentEventsSelector;
  organisations: IOrganisationsSelector;
  teamPaymentRequests: any;
  groups: IGroupsSelector;
  actions: any;
  isLoading: boolean;
  errors: any;
}

interface IListPaymentsAllTeamsState {
  paymentStatus: any;
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class ListPaymentsAllTeams extends React.Component<
IListPaymentsAllTeamsProps,
IListPaymentsAllTeamsState
> {
  static defaultProps: IListPaymentsAllTeamsProps = {
    paymentEvents: {},
    teams: {},
    organisations: {},
    teamPaymentRequests: {},
    groups: {},
    actions: undefined,
    isLoading: false,
    appReady: false,
    errors: {},
  };

  state: IListPaymentsAllTeamsState = {
    paymentStatus: { id: 'pending', name: 'Unpaid' },
  };

  componentDidMount = () => {
    // if (!this.props.teams.currentTeam.connectedToAssociation) {
    //   history.push('/dashboard');
    // } else {
    this.props.actions.getAllPaymentEventsForAllTeams();
    // }
  };

  handleSelectPaymentStatus = (e): void => {
    this.setState({ paymentStatus: e });
  };

  renderPaymentCards = (): React.ReactNode => {
    const paymentCards = paymentEventsSelectors.getPaymentEventsByIdSortedDateFilterByStatus(
      this.props.paymentEvents.paymentEventsById,
      this.props.teams.currentTeam.group.id,
      this.state.paymentStatus.id,
    );
    if (!_.isEmpty(paymentCards)) {
      return _.map(paymentCards, (paymentEvent, key) => {
        const eventData = paymentEventsSelectors.getPaymentEventForMatchCard(
          paymentEvent,
          this.props.teams.currentTeam.group.id,
        );
        if (eventData === undefined) {
          return null;
        }
        return (
          <div className="row with-margin-bottom" key={key}>
            <div className="col">
              <PaymentCardMin {...eventData} />
            </div>
          </div>
        );
      });
    }
    return (
      <div className="text-center with-margin-top">
        <h2 className="text-grey text-weight-medium">There are no matches.</h2>
      </div>
    );
  };

  groupIds = () => {
    const groupIds = [];

    _.each(this.props.teams.teamsById, (t) => {
      _.each(t.groups, (g) => {
        if (!_.isEmpty(g?.id)) {
          groupIds.push({ teamId: t.id, groupId: g?.id });
        }
      });
    });

    return _.uniqBy(groupIds, (u) => u.groupId);
  }

  noConnectedTeams = (): boolean => this.props.teams.hasLoaded && _.isEmpty(this.groupIds());

  hasMultipleTeams = (): boolean => this.props.teams.hasLoaded && this.props.teams.teamIds?.length > 1;

  render(): React.ReactNode {
    const groupIds = this.groupIds();
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin title="Matches" />
          </div>
        </div>
        <div className={classnames('row with-margin-bottom', { 'd-none': !this.noConnectedTeams() })}>
          <div className="col">
            <Notification
              onClick={(): any => history.push('/connect-team')}
            >
              <div className="d-inline-block">
                {!this.hasMultipleTeams() && (<h4>Your team is not connected to an association</h4>)}
                {this.hasMultipleTeams() && (<h4>None of your teams are not connected to an association</h4>)}
                <span className="with-margin-top">
                  Connect to your association so you can manage payments
                  &amp; submit forfeits.
                  {' '}
                  <Link className="primary" to="/connect-team">
                    Connect now &gt;
                  </Link>
                </span>
              </div>
            </Notification>
          </div>
        </div>
        {!this.noConnectedTeams() && (
          <div className={classnames('row')}>
            <div className="col">
              <MatchesTable
                {...this.props.paymentEvents}
                teamPaymentRequests={this.props.teamPaymentRequests}
                aggressiveLoader={false}
                groupIds={groupIds}
                showPayMultipleMatchesButton
                groupsById={this.props.groups.groupsById}
                appReady={this.props.appReady}
                selectTeam={this.props.actions.selectTeam}
                actions={this.props.actions}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
